import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { FinalCTA } from './components/FinalCTA';
import { HomePage } from './pages/HomePage';
import { HumanCapabilityPage } from './pages/HumanCapabilityPage';
import { SemanticKnowledgePage } from './pages/SemanticKnowledgePage';
import { CJIPage } from './pages/CJIPage';
import { NCJIPage } from './pages/NCJIPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './pages/ResearchPage';
import { RoadmapPage } from './pages/RoadmapPage';
import { InvestPage } from './pages/InvestPage';
import { LlmVsSkpPage } from './pages/LlmVsSkpPage';
import { NoetivraPage } from './pages/NoetivraPage';
import { PartnershipsPage } from './pages/PartnershipsPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './pages/applications/GovernmentPage';
import { EducationPage } from './pages/applications/EducationPage';
import { EmployersPage } from './pages/applications/EmployersPage';
import { CivilSocietyPage } from './pages/applications/CivilSocietyPage';
import { LeadershipPage } from './pages/applications/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
import { IndividualLevelPage } from './components/IndividualLevelPage';
import { OrganizationalLevelPage } from './components/OrganizationalLevelPage';
import { MunicipalScalePage } from './components/MunicipalScalePage';
import { NationalScalePage } from './components/NationalScalePage';
import { CognocracyPage } from './pages/projects/CognocracyPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { applyPageMeta } from './utils/pageMeta';
type RouteConfig = {
  page: React.ComponentType;
  withCTA: boolean;
};
const routes: Record<string, RouteConfig> = {
  '/': {
    page: HomePage,
    withCTA: false
  },
  '/human-capability': {
    page: HumanCapabilityPage,
    withCTA: false
  },
  '/semantic-knowledge': {
    page: SemanticKnowledgePage,
    withCTA: false
  },
  '/llm-vs-skp': {
    page: LlmVsSkpPage,
    withCTA: false
  },
  '/noetivra': {
    page: NoetivraPage,
    withCTA: false
  },
  '/cji': {
    page: CJIPage,
    withCTA: true
  },
  '/ncji': {
    page: NCJIPage,
    withCTA: true
  },
  '/solutions': {
    page: SolutionsPage,
    withCTA: false
  },
  '/about': {
    page: AboutPage,
    withCTA: false
  },
  '/research': {
    page: ResearchPage,
    withCTA: false
  },
  '/roadmap': {
    page: RoadmapPage,
    withCTA: false
  },
  '/partnerships': {
    page: PartnershipsPage,
    withCTA: false
  },
  '/investors': {
    page: InvestPage,
    withCTA: false
  },
  '/contact': {
    page: ContactPage,
    withCTA: false
  },
  '/privacy': {
    page: PrivacyPolicyPage,
    withCTA: false
  },
  '/terms': {
    page: TermsOfServicePage,
    withCTA: false
  },
  '/government': {
    page: GovernmentPage,
    withCTA: true
  },
  '/education': {
    page: EducationPage,
    withCTA: true
  },
  '/employers': {
    page: EmployersPage,
    withCTA: true
  },
  '/civil-society': {
    page: CivilSocietyPage,
    withCTA: true
  },
  '/leadership': {
    page: LeadershipPage,
    withCTA: true
  },
  '/reasoning-quality': {
    page: ReasoningQualityPage,
    withCTA: true
  },
  '/consequential-thinking': {
    page: ConsequentialThinkingPage,
    withCTA: true
  },
  '/manipulation-resistance': {
    page: ManipulationResistancePage,
    withCTA: true
  },
  '/emotional-regulation': {
    page: EmotionalRegulationPage,
    withCTA: true
  },
  '/social-cooperation': {
    page: SocialCooperationPage,
    withCTA: true
  },
  '/self-direction': {
    page: SelfDirectionPage,
    withCTA: true
  },
  '/leadership-responsibility': {
    page: LeadershipResponsibilityPage,
    withCTA: true
  },
  '/individual-level': {
    page: IndividualLevelPage,
    withCTA: true
  },
  '/organizational-level': {
    page: OrganizationalLevelPage,
    withCTA: true
  },
  '/municipal-scale': {
    page: MunicipalScalePage,
    withCTA: true
  },
  '/national-scale': {
    page: NationalScalePage,
    withCTA: true
  },
  '/projects': {
    page: ProjectsPage,
    withCTA: false
  },
  '/projects/cognocracy': {
    page: CognocracyPage,
    withCTA: false
  }
};
export function App() {
  const [path, setPath] = useState(getInitialPath);
  useEffect(() => {
    const handlePopState = () => {
      setPath(normalizePath(window.location.pathname));
      window.scrollTo(0, 0);
    };
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = (event.target as HTMLElement).closest('a');
      if (!anchor || anchor.target === '_blank') return;
      const rawHref = anchor.getAttribute('href');
      if (!rawHref || rawHref.startsWith('//')) return;
      // Same-page section links ("#clinical") resolve against the current page.
      const href = rawHref.startsWith('#') ? `${window.location.pathname}${rawHref}` : rawHref;
      if (!href.startsWith('/')) return;
      event.preventDefault();
      const [rawPath, hash] = href.split('#');
      const nextPath = normalizePath(rawPath);
      const nextUrl = hash ? `${nextPath}#${hash}` : nextPath;
      if (nextUrl !== window.location.pathname + window.location.hash) {
        window.history.pushState({}, '', nextUrl);
      }
      const samePage = nextPath === normalizePath(window.location.pathname);
      setPath(nextPath);
      if (hash) {
        // Wait for the destination page to render before scrolling to its section.
        window.setTimeout(() => scrollToHash(hash, samePage), samePage ? 0 : 50);
      } else {
        window.scrollTo(0, 0);
      }
    };

    // Deep links such as /noetivra#clinical opened directly.
    const initialHash = window.location.hash.slice(1);
    if (initialHash && routes[normalizePath(window.location.pathname)]) {
      window.setTimeout(() => scrollToHash(initialHash, false), 100);
    }
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  useEffect(() => {
    applyPageMeta(routes[path] ? path : '/');
  }, [path]);
  const route = routes[path] ?? routes['/'];
  const Page = route.page;
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-0" data-mp="2yicxurf326dj">
      <Navigation data-id="element-1" data-mp="3i3d610nw8o0k" />
      <main data-id="element-2" data-mp="3i4xxghewvqu7">
        <Page data-id="element-3" data-mp="3i4egb2x356h8" />
        {route.withCTA && <FinalCTA data-id="element-4" data-mp="3n2pufpuey359" />}
      </main>
      <Footer data-id="element-5" data-mp="3n1oep82gcsh7" />
    </div>;
}

// Scrolls to a section, leaving room for the fixed header. Works on mobile
// browsers that ignore scroll-margin with scrollIntoView.
function scrollToHash(hash: string, smooth: boolean) {
  const target = document.getElementById(decodeURIComponent(hash));
  if (!target) {
    window.scrollTo(0, 0);
    return;
  }
  const header = document.querySelector('header');
  const offset = (header?.getBoundingClientRect().height ?? 72) + 16;
  const top = target.getBoundingClientRect().top + window.scrollY - offset;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: smooth && !reduceMotion ? 'smooth' : 'auto'
  });
}

// Renamed pages keep working at their old addresses.
const renamedPaths: Record<string, string> = {
  '/research-areas': '/roadmap',
  '/invest': '/investors',
  '/initiatives': '/projects',
  '/initiatives/cognocracy': '/projects/cognocracy'
};
function normalizePath(pathname: string) {
  const clean = pathname.replace(/\/+$/, '');
  const path = clean === '' ? '/' : clean;
  return renamedPaths[path] ?? path;
}

// Old links used "#page" addresses (e.g. /#cji). Redirect them to clean paths.
function getInitialPath() {
  const legacy = window.location.hash.slice(1);
  const onRoot = window.location.pathname === '/' || window.location.pathname === '';
  if (legacy && onRoot) {
    const legacyPath = legacy === 'home' ? '/' : `/${legacy}`;
    if (routes[legacyPath]) {
      window.history.replaceState({}, '', legacyPath);
      return legacyPath;
    }
  }
  return normalizePath(window.location.pathname);
}